import React from 'react';
import {string, func} from 'prop-types';
import classNames from 'classnames';

import {Nav as baseStyle} from './Nav.scss';

export class Nav extends React.PureComponent {
  static propTypes = {
    id: string,
    className: string,
    text: string.isRequired,
    href: string.isRequired,
    onClick: func,
  };

  onClick = (event) => this.props.onClick ? this.props.onClick(event) : null;

  render() {
    const {id, className, text, href} = this.props;
    return (
      <li className={classNames(baseStyle, className)} onClick={this.onClick}>
        <a id={id} href={href}>{text}</a>
      </li>
    );
  }
}

export default Nav;
